import React from 'react'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { TimelineBlockBase } from '@common/Timeline'
import { Flex, Text } from '@fundamentals'
import { localizedStrings } from '@core/strings'
import { Chip } from '@common/material'
import EastIcon from '@mui/icons-material/East'

type ComponentProps = {
  auditResult: AuditResult
}
export const TimelineOrganisationFeatureFlagsBlock: React.FC<
  ComponentProps
> = ({ auditResult }) => {
  const translateFeatureFlag = (flag: string) => {
    switch (flag) {
      case 'STRICT_COMPANY_MANAGEMENT':
        return localizedStrings.strictCompanyManagement
      default:
        return flag
    }
  }
  const renderFeatureFlags = (
    featureFlags?: Record<string, { enabled: boolean }>,
  ) => {
    if (!featureFlags) {
      return <Text variant='body2'>-</Text>
    }

    return Object.entries(featureFlags).map(([flag, value]) => (
      <Text key={flag} variant='body2'>
        {`${translateFeatureFlag(flag)}: ${value.enabled}`}
      </Text>
    ))
  }

  const renderFeatureFlagsTrail = (
    preFeatureFlags?: Record<string, { enabled: boolean }>,
    postFeatureFlags?: Record<string, { enabled: boolean }>,
  ) => {
    if (!preFeatureFlags && !postFeatureFlags) {
      return <Text variant='body2'>-</Text>
    }

    const flagNames = Array.from(
      new Set([
        ...Object.keys(preFeatureFlags ?? {}),
        ...Object.keys(postFeatureFlags ?? {}),
      ]),
    )

    return flagNames.map((flag) => {
      const preEnabled =
        preFeatureFlags?.[flag]?.enabled === undefined
          ? false
          : preFeatureFlags?.[flag]?.enabled
      const postEnabled = postFeatureFlags?.[flag]?.enabled

      return (
        <Flex key={flag} alignItems='center' justifyContent='flex-start'>
          <Text variant='body2' sx={{ mr: 1 }}>
            {translateFeatureFlag(flag)}
          </Text>
          <Chip
            size='small'
            color={preEnabled ? 'success' : 'default'}
            label={preEnabled === undefined ? '-' : String(preEnabled)}
          />
          <EastIcon sx={{ mx: 2, opacity: 0.5 }} />
          <Chip
            size='small'
            color={postEnabled ? 'success' : 'default'}
            label={postEnabled === undefined ? '-' : String(postEnabled)}
          />
        </Flex>
      )
    })
  }

  return (
    <>
      {auditResult?.isUpdatingOrganisationFeatureFlags() && (
        <>
          <TimelineBlockBase title={localizedStrings.flagTrail}>
            {renderFeatureFlagsTrail(
              auditResult.metadata?.preFeatureFlags,
              auditResult.metadata?.postFeatureFlags,
            )}
          </TimelineBlockBase>
        </>
      )}
    </>
  )
}
